
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nft-pools/history",
      function () {
        return require("private-next-pages/nft-pools/history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nft-pools/history"])
      });
    }
  